import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './styles.module.scss';

export interface ActiveFiltersCountButtonProps extends Omit<
  B.AnchorButtonProps,
  'icon' | 'minimal' | 'text' | 'active'
> {
  /** Number of active filters. If 0, the badge is hidden. */
  count: number;
  /** Optional label to show next to the badge (e.g. "Filters"). */
  label?: React.ReactNode;
  /** Override the active state; defaults to `count > 0`. */
  active?: boolean;
}

const ActiveFiltersCountButton: React.FC<ActiveFiltersCountButtonProps> = ({
  count,
  label,
  active,
  ...buttonProps
}) => {
  const isActive = active ?? count > 0;

  const text =
    label || count > 0 ? (
      <div className={cs.buttonText}>
        {label}
        {count > 0 ? <span className={cs.filterCircle}>{count}</span> : null}
      </div>
    ) : undefined;

  return <B.AnchorButton icon="filter" minimal active={isActive} text={text} {...buttonProps} />;
};

export default ActiveFiltersCountButton;
